import { render, staticRenderFns } from "./Holder.vue?vue&type=template&id=64e7de3e"
import script from "./Holder.vue?vue&type=script&lang=js"
export * from "./Holder.vue?vue&type=script&lang=js"
import style0 from "./Holder.vue?vue&type=style&index=0&id=64e7de3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports